<template>
  <div style="border-top: 1px solid #e2e2e2; padding: 20px 0">
    <ul style="display: flex; align-items: center; margin-top: 20px">
      <el-input
        v-model="state.selectFile.name"
        size="large"
        placeholder="--请选择文件--"
        readonly
      ></el-input>
      <el-upload
        action="#"
        :show-file-list="false"
        ref="uploadDom"
        accept=".xlsx"
        :auto-upload="false"
        :on-change="onFileChange"
      >
        <template #default>
          <el-button type="primary" size="large" style="margin-left: 10px">
            选择文件
          </el-button>
        </template>
      </el-upload>
    </ul>
  </div>
  <div style="display: flex; align-items: center; justify-content: center">
    <el-button type="success" @click="onSubmitImport">确定导入</el-button>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_import } from "@/http/employee";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  setup(props, { emit }) {
    const state = reactive({ selectFile: {} });
    onMounted(() => {});

    //选择文件
    const onFileChange = (file) => {
      state.selectFile = file;
    };

    const onSubmitImport = () => {
      if (!state.selectFile?.raw) {
        ElMessage({
          type: "warning",
          message: "请选择文件！",
          grouping: true,
        });
        return false;
      }

      const formData = new FormData();
      formData.append("file", state.selectFile.raw);
      employee_import(formData)
        .then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert("导入成功！", "导入结果通知", {
              type: "success",
              confirmButtonText: "确定",
              callback: () => {
                emit("success", true);
              },
            });
          }
        })
        .catch((err) => {
          ElMessage.error(err.data.msg);
          emit("success");
        });
    };

    return { state, onFileChange, onSubmitImport };
  },
};
</script>
<style scoped></style>
